export const UNCLOSE_DAY_FETCHING = 'UNCLOSE_DAY_FETCHING';
export const UNCLOSE_DAY_FETCHING_UNCLOSE = 'UNCLOSE_DAY_FETCHING_UNCLOSE';
export const UNCLOSE_DAY_GET_DATA = 'UNCLOSE_DAY_GET_DATA';
export const UNCLOSE_DAY_PROCESS = 'UNCLOSE_DAY_PROCESS';
export const UNCLOSE_DAY_CLEAR_ERRORS = 'UNCLOSE_DAY_CLEAR_ERRORS';
export const UNCLOSE_DAY_UPDATE_SELECTED = 'UNCLOSE_DAY_UPDATE_SELECTED';
export const UNCLOSE_DAY_CLEAR_SUMMARIES = 'UNCLOSE_DAY_CLEAR_SUMMARIES';
export const UNCLOSE_DAY_ERRORS = 'UNCLOSE_DAY_ERRORS';



// WEBPACK FOOTER //
// ./src/pages/uncloseday/state/uncloseday/types.js